(function () {
  if (window.__bbCategoryHub) return;
  window.__bbCategoryHub = true;

  function initRandom(root) {
    var nodes = root.querySelectorAll('[data-hub-images]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var img = el.querySelector('img');
      if (!img || img.getAttribute('src')) continue;
      var urls = (el.getAttribute('data-hub-images') || '').split('|').filter(Boolean);
      if (!urls.length) continue;
      img.src = urls[Math.floor(Math.random() * urls.length)];
      img.hidden = false;
    }
  }

  function initCarousel(root) {
    var track = root.querySelector('[data-hub-track]');
    if (!track || track.getAttribute('data-hub-bound') === '1') return;
    track.setAttribute('data-hub-bound', '1');
    var prev = root.querySelector('[data-hub-prev]');
    var next = root.querySelector('[data-hub-next]');

    function step() {
      var tile = track.querySelector('[data-hub-tile]');
      return tile ? tile.getBoundingClientRect().width : Math.round(track.clientWidth * 0.88);
    }

    function go(dir) {
      track.scrollBy({ left: dir * step(), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
  }

  function boot(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var sections = root.querySelectorAll('[data-category-hub]');
    if (scope && scope.matches && scope.matches('[data-category-hub]')) {
      initRandom(scope);
      initCarousel(scope);
    }
    for (var i = 0; i < sections.length; i++) {
      initRandom(sections[i]);
      initCarousel(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
